import fetch from '@/utils/axios';

export const logToServer = (data: Record<string, any>, options: { tags?: string[]; level?: string } = {}) => {
  fetch
    .post(
      '/ec/bff/common/log/record',
      {
        data,
        level: options?.level,
        tags: options?.tags,
        localDate: `${new Date().toLocaleString()}`,
        isoDate: `${new Date().toISOString()}`
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-page-url': window.location.href
        }
      }
    )
    .then(res => {
      console.log('ok');
    })
    .catch(err => {
      console.log(err, 'err');
    });
};

export const logWebVitals = (data: Record<string, any>, tags: string[] = []) => {
  logToServer(data, {
    tags,
    level: 'info'
  });
};
